<div class="node-time-line" [ngClass]="{ last: last }">
  <div class="circle">
    <div class="sub-circle">
      <div class="point"></div>
    </div>
  </div>
  <div class="title">{{ title }}</div>
  <ng-content> </ng-content>
</div>
